import {TYPE} from "vue-toastification";

export default {
    toastDefaults: {
        // ToastOptions object for each type of toast
        [TYPE.ERROR]: {
            hideProgressBar: true,
            position: 'bottom-right'
        },
        [TYPE.SUCCESS]: {
            hideProgressBar: true,
            position: 'bottom-right'
        }
    }
};